export default __webpack_public_path__ + "static/media/012-gas station.3fdf15a6.svg";